const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";
const runtimeProtocol = typeof window !== "undefined" ? window.location.protocol : "http:";
const runtimeHost = typeof window !== "undefined" ? window.location.hostname : "localhost";
const runtimePort = typeof window !== "undefined" ? window.location.port : "";

const DEFAULT_APP_BASE_URL =
  runtimePort === "3000" || runtimePort === "3001"
    ? `${runtimeProtocol}//${runtimeHost}:8000`
    : (runtimeOrigin || "http://localhost:8000");

const rawApiUrl = (process.env.REACT_APP_API_URL || "").trim();
const rawBackendBaseUrl = (process.env.REACT_APP_BACKEND_BASE_URL || "").trim();
const rawBaseUrl = (process.env.REACT_APP_BASE_URL || "").trim();
const rawAppUrl = (process.env.REACT_APP_URL || "").trim();
const cleanApiUrl = rawApiUrl.replace(/\/+$/, "");
const cleanBackendBaseUrl = rawBackendBaseUrl.replace(/\/+$/, "");
const cleanBaseUrl = rawBaseUrl.replace(/\/+$/, "");
const cleanAppUrl = rawAppUrl.replace(/\/+$/, "");
// Priority:
// 1) REACT_APP_API_URL (full API URL)
// 2) REACT_APP_BACKEND_BASE_URL (backend base URL; /api suffix added automatically)
// 3) REACT_APP_BASE_URL (alias of backend base URL; /api suffix added automatically)
// 4) REACT_APP_URL
// 5) Runtime auto-detect (frontend host + :8000 when running on :3000/:3001)
const baseCandidate = cleanApiUrl || cleanBackendBaseUrl || cleanBaseUrl || cleanAppUrl;
const hasApiSuffix = /\/api$/i.test(baseCandidate);

export const API_BASE_URL = (
  baseCandidate
    ? hasApiSuffix
      ? baseCandidate
      : `${baseCandidate}/api`
    : `${DEFAULT_APP_BASE_URL}/api`
).replace(/\/+$/, "");

export const APP_BASE_URL = (
  API_BASE_URL.replace(/\/api$/i, "") || DEFAULT_APP_BASE_URL
).replace(/\/+$/, "");

export const apiUrl = (path = "") => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${normalized}`;
};

const stripSlashes = (value = "") =>
  String(value).replace(/\\/g, "/").replace(/^\/+|\/+$/g, "");

const normalizeUploadPath = (value = "") => {
  const normalized = stripSlashes(value);
  // Keep backward compatibility: old DB rows may store `players/...`
  // while files are saved under `uploads/Players/...`.
  if (/^players\//i.test(normalized)) {
    return `Players/${normalized.replace(/^players\//i, "")}`;
  }
  return normalized;
};

const uploadsUrl = (uploadPath = "") =>
  `${API_BASE_URL}/uploads/${normalizeUploadPath(uploadPath)}`;

export const resolveAssetUrl = (path, options = {}) => {
  const {
    folder = "",
    entityId = null,
    defaultPath = "",
  } = options;

  const normalizedDefaultPath = (() => {
    const rawDefault = typeof defaultPath === "string" ? defaultPath.trim() : defaultPath;
    return rawDefault ? rawDefault : null;
  })();

  if (!path) return normalizedDefaultPath;

  const raw = String(path).trim();
  if (!raw) return normalizedDefaultPath;

  if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) {
    return raw;
  }

  if (raw.startsWith("/uploads/")) {
    const normalizedUploads = normalizeUploadPath(
      stripSlashes(raw).replace(/^uploads\//i, "")
    );
    return uploadsUrl(normalizedUploads);
  }

  if (raw.startsWith("uploads/")) {
    const normalizedUploads = normalizeUploadPath(
      stripSlashes(raw).replace(/^uploads\//i, "")
    );
    return uploadsUrl(normalizedUploads);
  }

  if (raw.startsWith("/")) {
    return `${APP_BASE_URL}${raw}`;
  }

  const normalized = normalizeUploadPath(raw);
  const normalizedFolder = stripSlashes(folder);

  let candidate = normalized;

  if (normalizedFolder) {
    const startsWithFolder = new RegExp(`^${normalizedFolder}/`, "i").test(
      normalized
    );

    if (!startsWithFolder) {
      if (entityId && !normalized.includes("/")) {
        candidate = `${normalizedFolder}/${entityId}/${normalized}`;
      } else {
        candidate = `${normalizedFolder}/${normalized}`;
      }
    }
  }

  return uploadsUrl(candidate);
};
